import { useAbortOnUnmount } from './useAppShellChatRouteSync/useAbortOnUnmount'
import { useAbortOnThreadChange } from './useAppShellChatRouteSync/useAbortOnThreadChange'
import { useValidateUrlThread } from './useAppShellChatRouteSync/useValidateUrlThread'
import { useSyncDisplayThreadUrl } from './useAppShellChatRouteSync/useSyncDisplayThreadUrl'
import { useBoardsAllRouteRedirect } from './useAppShellChatRouteSync/useBoardsAllRouteRedirect'
import { useSyncHomeProductFromPath } from './useAppShellChatRouteSync/useSyncHomeProductFromPath'

/**
 * URL ↔ home thread alignment + abort in-flight chat when display thread changes.
 * @param {object} m — return value of `useAppShellChatModel`
 */
export function useAppShellChatRouteSync(m) {
  useAbortOnUnmount(m)
  useAbortOnThreadChange(m)
  useValidateUrlThread(m)
  useSyncDisplayThreadUrl(m)
  useBoardsAllRouteRedirect(m)
  useSyncHomeProductFromPath(m)
}
